import React from 'react';
import LootboxSheet from '../../lootbox/components/LootboxSheet';
import { formatAmount } from '../utils/missionMath';
import { missionName, resolveAssetUrl, rewardIcon, rewardName } from '../utils/lairAssets';
import { useTranslation } from 'react-i18next';

/** Result popup after claiming a mission run. */
export default function MissionResultSheet({ run, onClose }) {
  const { t } = useTranslation();
  const success = !!run.success;
  const rewards = run.rewards || [];

  return (
    <LootboxSheet
      title={missionName(run, t) || t('lair.mission', 'Mission')}
      onClose={onClose}
      footer={(closeThen) => (
        <button type="button" className="app-btn app-btn--green" onClick={() => closeThen()}>
          {success ? t('lair.result.great', 'Great!') : t('common.ok', 'OK')}
        </button>
      )}
    >
      <div className={`lair-result ${success ? 'lair-result--ok' : 'lair-result--fail'}`}>
        <div className="lair-result__stage">
          <div className="lair-result__glow" />
          <img src={resolveAssetUrl(run.missionImageUrl) || '/lair/patrol.svg'} alt="" />
        </div>
        <div className="lair-result__headline">{success ? t('lair.result.success', 'SUCCESS') : t('lair.result.failed', 'FAILED')}</div>
        <div className="lair-result__sub">
          {success
            ? t('lair.result.back_with_loot', 'Your hero is back with loot')
            : rewards.length
              ? t('lair.result.saved_part', 'Your hero saved a part of the loot')
              : t('lair.result.empty', 'Your hero came back empty-handed')}
        </div>
      </div>

      {rewards.length > 0 && (
        <div className="chest-info-drops" style={{ '--cols': Math.min(rewards.length, 4) }}>
          {rewards.map((r, i) => {
            const icon = rewardIcon(r);
            return (
              <div key={`${r.rewardType}-${r.resourceCode || r.moduleId || ''}-${i}`} className="chest-info-drop-cell lair-result__cell">
                <div className="chest-info-drop-icon-wrap">
                  {icon
                    ? <img src={icon} alt={rewardName(r, t)} className="chest-info-drop-icon" />
                    : <span className="chest-info-drop-icon-placeholder">?</span>}
                </div>
                <span className="chest-info-drop-name">{rewardName(r, t)}</span>
                <span className="chest-info-drop-value">+{formatAmount(r.amount)}</span>
              </div>
            );
          })}
        </div>
      )}
    </LootboxSheet>
  );
}
